import { ConfluenceLogo } from '@atlaskit/logo';
import { CobrandingComponents } from '../../../../components/whitebox-cobranding/shared-cobranding';
import { ConfluenceBackground } from '@atlassian/product-wireframes';

const AdminExperimentForConfluence: CobrandingComponents = {
  background: ConfluenceBackground,
  logo: { component: ConfluenceLogo },
  footerProducts: 'Jira, Confluence, Trello',
};

export default AdminExperimentForConfluence;
